import React, {useEffect, useState} from 'react';
import './HeroSection.css';
import {useNavigate} from 'react-router-dom';
// import shop_cvijet from '../images/cvijet cropped.jpg'
import kapljice from '../images/home/home7.jpg'
import shop from '../images/home/shop1.webp'

// import creme_face from '../images/salon_lice cropped.jpg'
// import facial from '../images/natpis2 novi copy cropped.png'
// import facial_mala from '../images/naslovna manja.png'
import home3 from '../images/home/home5.webp'
import home2 from '../images/home/home10.png'
// import home2 from '../images/home/home2_visoka.jpg'
import "../fonts/fonts.css"


function HeroSection() {
    // const loggedIn = localStorage.getItem("loggedIn") === "true"
    let navigate = useNavigate();
    const [aspectRatio, setAspectRatio] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            const ratio = window.innerHeight / window.innerWidth;
            setAspectRatio(ratio);
        };

        handleResize(); // Initial calculation

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // //console.log(aspectRatio)



  return (
        <div className="hero-section">
            {/*<Navbar/>*/}
            <div className="image-container2">
                {/*<img src={imageSrc} className="" alt="photo"/>*/}
                <div id="image-container">
                    {aspectRatio >= 0.9 ? (
                        <img src={home2} alt="Vertical" />
                    ) : (
                        <img src={home3} alt="Horizontal" />
                    )}
                </div>
            </div>

            <div className="content">
            <div className="webshop-treatment-container">
                <div className="treatment-container">
                    <img src={shop}  className="webshop-photo" alt=""/>
                    <button id="hero-btn" type="button" className="font-tiskani-mali btn btn-primary margin-top centered-button"
                            onClick={() => navigate("/shop")}>
                        Webshop
                    </button>
                </div>
                <div className="webshop-container">
                    {/*<img src={creme_face} className="webshop-photo" alt=""/>*/}
                    <img src={kapljice} className="webshop-photo" alt=""/>
                    <button id="hero-btn" type="button" className="font-pro btn btn-primary margin-top centered-button"
                            onClick={() => navigate("/kontakt")}>
                        Kontakt
                    </button>
                </div>
            </div>
        </div>
        </div>
  );
}

export default HeroSection;
